import faker from "@faker-js/faker";
import { Customer } from "@src/core/models/customer";

export const mockCustomer = (overrides?: Customer): Customer => ({
  addressId: faker.datatype.uuid(),
  createdAt: faker.date.past(),
  createdBy: faker.datatype.uuid(),
  email: faker.internet.email(),
  id: faker.datatype.uuid(),
  name: faker.name.firstName(),
  lastName: faker.name.lastName(),
  phoneNumber: faker.phone.phoneNumber(),
  updatedAt: faker.date.past(),
  updatedBy: faker.datatype.uuid(),
  userId: faker.datatype.uuid(),
  ...(overrides || {}),
});
